import { CAMPAIGN_KEYS, safeCampaign, safeLandingPage } from "./signupAcquisition.ts";
import type { SignupAcquisition } from "./signupAcquisition.ts";

// App Store Connect Analytics campaign names allow up to 30 characters:
// https://developer.apple.com/help/app-store-connect-analytics/acquisition/campaign-links
export const APPLE_CAMPAIGN_TOKEN_LIMIT = 30;

/** Store campaign evidence stays separate from Stasht's own CTA location. */
export function storeLinkCampaign(surface: string, acquisition?: SignupAcquisition, page?: string) {
  const campaign: Record<string, string> = {};
  for (const key of CAMPAIGN_KEYS) {
    const value = safeCampaign(acquisition?.[key]);
    if (value) campaign[key] = value;
  }
  const landing = safeLandingPage(page || acquisition?.landing_page || "");
  const path = landing && new URL(landing).pathname;
  const contentPage = path && !["/", "/login", "/signup"].includes(path) ? path.replace(/^\/(?:blog\/)?/, "") : undefined;
  const hasCampaign = Object.keys(campaign).length > 0;
  const contextual = Boolean(contentPage || hasCampaign);
  // Partial external evidence stays partial; defaults describe only Stasht's
  // own untagged outbound CTA and must not complete an external campaign.
  const play = new URLSearchParams(hasCampaign ? campaign : { utm_source: "stasht.app", utm_medium: "web", utm_campaign: surface });
  const base = `stasht-web-${surface}`;
  if (!contextual) return { apple: base, play: play.toString() };
  play.set("stasht_surface", surface);
  if (landing) play.set("stasht_landing", new URL(landing).pathname);

  // Include a stable suffix within ASC's campaign-name limit
  // over the complete context so long article/campaign names retain distinction.
  const identity = JSON.stringify({ campaign, landing, surface });
  let hash = 2166136261;
  for (let index = 0; index < identity.length; index++) hash = Math.imul(hash ^ identity.charCodeAt(index), 16777619);
  const suffix = (hash >>> 0).toString(36);
  const label = `${base}-${contentPage || campaign.utm_campaign || campaign.utm_source || "campaign"}`;
  return { apple: `${label.slice(0, APPLE_CAMPAIGN_TOKEN_LIMIT - 1 - suffix.length)}-${suffix}`, play: play.toString() };
}
